module.exports = __webpack_public_path__ + "static/media/12sullyintroskit.7eadb30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12sullyintroskit.png
// module id = 111
// module chunks = 0